import { render, staticRenderFns } from "./ProjectViewSidebarMessagesCardMsgBubble.vue?vue&type=template&id=f74559e6&scoped=true"
import script from "./ProjectViewSidebarMessagesCardMsgBubble.vue?vue&type=script&lang=ts"
export * from "./ProjectViewSidebarMessagesCardMsgBubble.vue?vue&type=script&lang=ts"
import style0 from "./ProjectViewSidebarMessagesCardMsgBubble.vue?vue&type=style&index=0&id=f74559e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74559e6",
  null
  
)

export default component.exports